import { APP } from '../../i18n/el';

// Υποσέλιδο. Το `PropTypes` αφαιρέθηκε: το React 19 δεν το ελέγχει πλέον, οπότε
// θα ήταν δήλωση χωρίς αποτέλεσμα.
//
// Εδώ ζει η **ταυτότητα της εργασίας**: πλήρης τίτλος, ονοματεπώνυμο και αριθμός
// μητρώου. Το υποσέλιδο είναι η σωστή θέση και όχι η κεφαλίδα, γιατί η κεφαλίδα
// φέρει τον τίτλο της **τρέχουσας οθόνης** — ο χρήστης τη διαβάζει για να ξέρει
// πού βρίσκεται, και ένας τίτλος 76 χαρακτήρων εκεί θα έπνιγε αυτή τη λειτουργία.

export default function Footer() {
    return (
        <footer className="mt-auto border-t border-border px-4 py-5 lg:px-6">
            <div className="flex flex-col items-center gap-1 text-center">
                <p className="text-sm font-medium">{APP.title}</p>
                <p className="text-sm text-muted">
                    {APP.author} <span aria-hidden="true">·</span> {APP.studentId}
                </p>
            </div>
        </footer>
    );
}
